// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2Ha0r","tab":"ProcedureTabs_tab__-TuRb"};